import { makeStyles } from "@mui/styles";
import { SIZING } from "theme";
export const useStyles = makeStyles(() => ({
        root:{
            marginLeft:SIZING.scale300,
            fontSize:SIZING.scale350,
            fontWeight:600
      },
}));